module.exports = __webpack_public_path__ + "img/symbol_2.871fcbd0.png";